import React from 'react';
import style from './style.module.css';

export default function IcNotification(props) {
  return (
		<span className={style.container} style={{background: props.bg, padding: props.padding, borderRadius: props.radius}}>
			<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" style={{fill: props.fill, height: props.size, width: props.size}}>
				<g>
					<path d="M12.2,11.4l-1-1.9V6.5c0-1.6-0.9-3-2.2-3.7C8.9,2.8,8.8,2.8,8.7,2.7C8.6,1.8,7.9,1.2,7,1.2c-0.9,0-1.6,0.7-1.7,1.5
						C5.1,2.8,5,2.8,4.9,2.9C3.6,3.7,2.8,5,2.8,6.5v2.9l-1,1.9c-0.2,0.4,0.1,0.8,0.5,0.8h3c0.1,0.4,0.4,0.7,0.8,0.9
						c0.3,0.2,0.5,0.2,0.9,0.2s0.6-0.1,0.9-0.2c0.4-0.2,0.6-0.5,0.8-0.9h3C12.1,12.3,12.4,11.8,12.2,11.4z M11.7,11.7
						C11.7,11.7,11.7,11.8,11.7,11.7l-9.4,0c0,0,0,0-0.1,0c0,0,0-0.1,0-0.1l1-1.9l0.1-0.1v-3c0-1.4,0.8-2.6,2-3.3
						c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0,0,0,0L5.7,3v0C6,2.9,6.5,2.8,7,2.8c0.5,0,1,0.1,1.3,0.2v0l0.2,0.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1
						c1.3,0.6,2,1.9,2,3.3v3l0.1,0.1L11.7,11.7C11.8,11.7,11.8,11.7,11.7,11.7z"/>
					<path d="M7,13.5c-0.3,0-0.6-0.1-0.9-0.3c-0.4-0.2-0.6-0.5-0.8-0.9h-3c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.2-0.1-0.5,0-0.7l1-1.9V6.5
						c0-1.5,0.8-2.9,2.1-3.7c0.1-0.1,0.2-0.1,0.4-0.2C5.3,1.7,6.1,1.1,7,1.1c0.9,0,1.7,0.7,1.8,1.6c0.1,0,0.2,0.1,0.3,0.1
						c1.4,0.7,2.2,2.2,2.2,3.8v2.9l1,1.9c0.1,0.2,0.1,0.5,0,0.7c-0.1,0.2-0.3,0.3-0.6,0.3h-3c-0.2,0.4-0.4,0.7-0.8,0.9
						C7.6,13.4,7.3,13.5,7,13.5z M7,1.3c-0.8,0-1.5,0.6-1.6,1.5l0,0.1l-0.1,0C5.2,2.9,5,2.9,4.9,3c-1.2,0.7-2,2.1-2,3.5l0,3l-1,1.9
						c-0.1,0.2-0.1,0.3,0,0.5c0.1,0.1,0.2,0.2,0.4,0.2h3.1l0,0.1c0.1,0.4,0.4,0.7,0.7,0.9c0.5,0.3,1.1,0.3,1.6,0
						c0.3-0.2,0.6-0.5,0.7-0.9l0-0.1h3.1c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0-0.5l-1-2V6.5C11.1,5,10.3,3.7,9,3
						C8.9,2.9,8.8,2.8,8.7,2.8l0,0l0-0.1C8.5,1.9,7.8,1.3,7,1.3z M11.7,11.8H2.3c-0.1,0-0.1,0-0.2-0.1l0,0c0,0,0-0.1,0-0.1l1-2v-3
						c0-1.4,0.8-2.7,2-3.4c0,0,0.1-0.1,0.2-0.1l0.1,0c0,0,0.1,0,0.1,0l0.2-0.1C6,2.8,6.5,2.8,7,2.8c0.5,0,1,0.1,1.3,0.2l0.1,0v0L8.5,3
						c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c1.3,0.6,2.1,2,2.1,3.4v3l0,0.1l1,1.9c0,0.1,0,0.1,0,0.1l0,0C11.8,11.8,11.7,11.8,11.7,11.8z
						M11.7,11.7C11.7,11.7,11.7,11.7,11.7,11.7L11.7,11.7z M2.4,11.7h9.3l-1-2.1v-3c0-1.4-0.8-2.6-2-3.2c0,0-0.1,0-0.1-0.1l0,0L8.2,3.1
						C7.9,3,7.5,3,7,3C6.5,3,6.1,3,5.8,3.1l0,0L5.5,3.3l0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1C4.1,4,3.4,5.2,3.4,6.5l0,3.1L3.3,9.7
						L2.4,11.7z"/>
				</g>
			</svg>
		</span>
  );
}
